import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { Popup, Flex } from 'nallian-shared-ui/lib/components';
import { NoBreakSpan } from '../../../../app/styles';

const IdentificationCodes = ({ value }) => {
  const { t } = useTranslation();

  if (!value?.length) {
    return <i>{t('noIdentificationCodes')}</i>;
  }

  return (
    <Popup
      content={
        <Flex direction="column">
          {value.map(idcode => (
            <div key={idcode.id}>{`${idcode.type?.name}: ${idcode.value}`}</div>
          ))}
        </Flex>
      }
      on="hover"
      hoverable
      trigger={<NoBreakSpan>{t('identificationCodesCount', { count: value.length })}</NoBreakSpan>}
    />
  );
};

IdentificationCodes.propTypes = { value: PropTypes.array };
IdentificationCodes.defaultProps = { value: [] };

export default IdentificationCodes;
